import { Dispatch } from "redux";
import {
  SET_LOGIN,
  SET_LOGOUT,
  SetLoginAction,
  SetLogoutAction,
} from "../../actions-Types/actionTypes";
import { LoginDetails } from "../../../types/login";
import { normalizeLoginResponse } from "../../../helper/normalizeLoginResponse";

export const loginDetails =
  (data: LoginDetails | Record<string, unknown>) =>
  (dispatch: Dispatch<SetLoginAction>) => {
    try {
      dispatch({
        type: SET_LOGIN,
        payload: normalizeLoginResponse(data as Record<string, unknown>),
      });
    } catch (err) {
      console.error("Failed to dispatch login action", err);
    }
  };

export const setUserLogoutData =
  () => (dispatch: Dispatch<SetLogoutAction>) => {
    try {
      dispatch({
        type: SET_LOGOUT,
      });
    } catch (err) {
      console.error("Failed to dispatch Logout action", err);
    }
  };
